// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"15177044","298":"7a604efb"}[chunkId] + ".js";
};